export const HANUMAN_COLORS = {
  primary: '#C62828',
  primaryDark: '#8D1A1A',
  accent: '#FF7043',
  accentDark: '#D84315',
  gold: '#FFB300',
  cream: '#FFF8E1',
  cellBorder: 'rgba(198, 40, 40, 0.3)',
  tappedBg: '#FFE0B2',
  tappedBorder: '#C62828',
  pathGlow: 'rgba(255, 112, 67, 0.5)',
  textPrimary: '#3E1F0A',
  textSecondary: '#9B6D4A',
};

export const HANUMAN_GRID_PALETTE = {
  cellBg: HANUMAN_COLORS.cream,
  cellBorder: HANUMAN_COLORS.cellBorder,
  tappedBg: HANUMAN_COLORS.tappedBg,
  tappedBorder: HANUMAN_COLORS.tappedBorder,
  pathGlow: HANUMAN_COLORS.pathGlow,
  primaryColor: HANUMAN_COLORS.textPrimary,
  secondaryColor: HANUMAN_COLORS.textSecondary,
};
